import {
    createContext,
    type KeyboardEvent,
    type PointerEvent,
    useContext,
} from "react";

/** A pointer or key press that may pick something up. */
export type DragStartEvent =
    | PointerEvent<HTMLElement>
    | KeyboardEvent<HTMLElement>;

/** What row drag handles need; stable while the table's state holds still. */
export interface RowDragContextValue {
    /** Hands a press on a row's handle to the drag sensors. */
    startRowDrag: (event: DragStartEvent, rowId: string) => void;
    /** Sorted or grouped: display order isn't row order, so rows stay put. */
    isBlocked: boolean;
    /** Id of the keyboard instructions the handles describe themselves with. */
    instructionsId: string;
}

/** What draggable headers need. */
export interface ColumnDragContextValue {
    startColumnDrag: (
        event: PointerEvent<HTMLElement>,
        columnId: string,
    ) => void;
}

export const RowDragContext = createContext<RowDragContextValue | null>(null);

export const ColumnDragContext = createContext<ColumnDragContextValue | null>(
    null,
);

/** Null when the table has no `rowReorder`. */
export const useRowDrag = () => useContext(RowDragContext);

/** Null when the table has no `columnReorder`. */
export const useColumnDrag = () => useContext(ColumnDragContext);

export const ROW_DRAG_ID = "dt-row-drag";
export const COLUMN_DRAG_ID = "dt-column-drag";
